import { render, staticRenderFns } from "./OriginList.vue?vue&type=template&id=0ba64058&"
import script from "./OriginList.vue?vue&type=script&lang=js&"
export * from "./OriginList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports